import React from "react";
import "./App.scss";
import AboutUs from "./components/aboutUs/AboutUs";
import Content from "./components/content/Content.js";
import Post from "./components/post/Post";
import Main from "./components/main/Main.js";
import NoMatch from "./components/noMatch/NoMatch";
import Contact from "./components/contact/Contact";
import Admin from "./components/admin/Admin";
import PrivateRoute from "./components/privateRoute/PrivateRoute";
import Login from "./components/login/Login";

const routes = {
  data: [
    { path: "/", element: <Main /> },
    { path: "/bajki", element: <Content /> },
    { path: "/artykuly", element: <Content /> },
    { path: "/bajki/:title", element: <Post /> },
    { path: "/artykuly/:title", element: <Post /> },
    { path: "/o-mnie", element: <AboutUs /> },
    { path: "/kontakt", element: <Contact /> },
    { path: "/login", element: <Login /> },
    { path: "*", element: <NoMatch /> },
    {
      path: "/admin",
      element: (
          <PrivateRoute>
            <Admin />
          </PrivateRoute>
      ),
    },
    { path: "*", element: <NoMatch /> },
  ]
};

export default routes;
